<template>
  <div class="container-main">
    <div class="container-state" v-for="state in states">
      <h3>
        {{ state.uf }}
      </h3>
      <div class="container-status">
        <div
          v-for="model in state.models"
          class="block-status"
          :class="{
            'block-status-green': !model.in_contingency,
            'block-status-red': model.in_contingency,
          }"
        >
          <span>
           {{ model.model_name }}
          </span>
          <span v-if="model.in_contingency">
            Contingência ativa até
          </span>
          <span v-if="model.in_contingency">
             {{ (new Date(model.until)).toLocaleString() }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.container-main {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}

.container-state {
  border: 1px solid #AAA;
  border-radius: 1rem;
  padding: 0.5rem;
}

.container-status {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0.5rem;
  margin-top: 0.5rem;
}

.block-status {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  border-radius: 1rem;
  padding: 1rem;
  align-content: start;
}

.block-status-green {
  background-color: #4caf50;
  color: white;
}

.block-status-red {
  background-color: #f44336;
  color: white;
}

</style>

<script>
export default {

  data() {
      return {
        states: []
      }
    },
    methods: {
        /*funcao para mostrar a page de loading enquanto busca os emails*/
        openLoading (active) {
            if (active) {
                this.$vs.loading({
                    type: "point",
                })
            } else {
                this.$vs.loading.close()
            }
        },
      async getStatus() {
        try {
          this.openLoading(true)
          const URI = `contingencia`
          await this.$axios.get(URI)
            .then((dados)=> {
              this.states = dados.data
            })
          this.openLoading(false)
        } catch (err) {
          console.warn(err)
        }
      }
    },
    mounted() {
      this.getStatus()
    }
}
</script>
